// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__Di_hx","obliqueLineWrap":"membershipbadge_obliqueLineWrap__17LtI","obliqueLine":"membershipbadge_obliqueLine__27tJK"};